var map = {
	"./Huamantla.png": 79548,
	"./Ixtenco.png": 49844,
	"./Tlaxco.png": 52884,
	"./aeropuerto.svg": 3780,
	"./barrios.svg": 16268,
	"./calvillo.PNG": 20892,
	"./gastronomia/huamantla/Huamantla1.jpg": 24868,
	"./gastronomia/huamantla/Huamantla2.jpg": 40380,
	"./gastronomia/huamantla/Huamantla3.jpg": 5888,
	"./gastronomia/huamantla/Huamantla4.jpg": 53860,
	"./gastronomia/ixtenco/Ixtenco1.jpg": 94712,
	"./gastronomia/ixtenco/Ixtenco2.jpg": 62528,
	"./gastronomia/ixtenco/Ixtenco3.jpg": 84784,
	"./gastronomia/ixtenco/Ixtenco4.jpg": 65815,
	"./gastronomia/tlaxco/Tlaxco1.jpg": 77571,
	"./gastronomia/tlaxco/Tlaxco2.jpg": 73384,
	"./gastronomia/tlaxco/Tlaxco3.jpg": 88416,
	"./gastronomia/tlaxco/Tlaxco4.jpg": 12964,
	"./islas.svg": 95332,
	"./logo_ciudades_pin.svg": 5268,
	"./logo_pin.svg": 19680,
	"./maya.svg": 80060,
	"./palmera.png": 46275,
	"./piramide-maya.png": 74764,
	"./sitios.svg": 33812,
	"./tren-maya.svg": 19076,
	"./tren.png": 72772,
	"./volcan.png": 2916
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36888;